import script from "./ChassisSectionStandardBev.vue?vue&type=script&setup=true&lang=js"
export * from "./ChassisSectionStandardBev.vue?vue&type=script&setup=true&lang=js"

import "./ChassisSectionStandardBev.vue?vue&type=style&index=0&id=f830ae9c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f830ae9c"]])

export default __exports__